(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const cache = new Map();
  let requestToken = 0;

  const text = (node) => (node && node.textContent ? node.textContent.trim() : '');

  function previewPanel(menu) {
    return menu.querySelector('.mega-menu__content-list--products') ||
      menu.querySelector('.mega-menu__content');
  }

  function productData(doc) {
    return Array.from(doc.querySelectorAll('.product-grid__item')).slice(0, 3).map((card) => {
      const titleNode = card.querySelector('[role="heading"], h3, .resource-card__title');
      const titleLink = titleNode && titleNode.closest('a');
      const anyLink = card.querySelector('a[href*="/products/"]');
      const image = card.querySelector('img');
      const priceNode = card.querySelector('product-price, [ref="priceContainer"], .price');
      return {
        title: text(titleNode),
        href: (titleLink || anyLink)?.href || '',
        image: image?.currentSrc || image?.src || '',
        alt: image?.alt || text(titleNode),
        price: text(priceNode)
      };
    }).filter((item) => item.title && item.href);
  }

  function render(panel, title, products, href) {
    panel.classList.add('ninja-mega-preview');
    panel.setAttribute('aria-live', 'polite');
    panel.innerHTML = '';

    const heading = document.createElement('div');
    heading.className = 'ninja-mega-preview__heading';
    heading.innerHTML = '<span>Aperçu de la collection</span><strong></strong>';
    heading.querySelector('strong').textContent = title;
    panel.appendChild(heading);

    const grid = document.createElement('div');
    grid.className = 'ninja-mega-preview__grid';
    products.forEach((product) => {
      const card = document.createElement('a');
      card.className = 'ninja-mega-preview__card';
      card.href = product.href;

      const media = document.createElement('span');
      media.className = 'ninja-mega-preview__media';
      if (product.image) {
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = product.alt;
        img.loading = 'eager';
        media.appendChild(img);
      }

      const body = document.createElement('span');
      body.className = 'ninja-mega-preview__body';
      const name = document.createElement('strong');
      name.textContent = product.title;
      const price = document.createElement('span');
      price.className = 'ninja-mega-preview__price';
      price.textContent = product.price;
      body.append(name, price);
      card.append(media, body);
      grid.appendChild(card);
    });
    panel.appendChild(grid);

    const more = document.createElement('a');
    more.className = 'ninja-mega-preview__more';
    more.href = href;
    more.textContent = 'Voir toute la collection →';
    panel.appendChild(more);
  }

  function loading(panel, title) {
    panel.classList.add('ninja-mega-preview');
    panel.innerHTML = '<div class="ninja-mega-preview__loading"><span></span><strong></strong><small>Chargement de la sélection…</small></div>';
    panel.querySelector('strong').textContent = title;
  }

  async function activate(link, menu) {
    if (!desktop.matches) return;
    const panel = previewPanel(menu);
    if (!panel) return;

    menu.querySelectorAll('.mega-menu__list a').forEach((item) => {
      item.classList.toggle('ninja-mega-preview__active', item === link);
    });

    const href = new URL(link.href, window.location.origin).href;
    const title = text(link);
    const token = ++requestToken;

    if (cache.has(href)) {
      render(panel, title, cache.get(href), href);
      return;
    }

    loading(panel, title);
    try {
      const response = await fetch(href, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Collection unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const products = productData(doc);
      if (!products.length) throw new Error('No products');
      cache.set(href, products);
      if (token === requestToken) render(panel, title, products, href);
    } catch (_) {
      if (token !== requestToken) return;
      panel.innerHTML = '';
      const fallback = document.createElement('a');
      fallback.className = 'ninja-mega-preview__fallback';
      fallback.href = href;
      fallback.textContent = 'Découvrir ' + title + ' →';
      panel.appendChild(fallback);
    }
  }

  function bind(menu) {
    if (menu.dataset.ninjaPreviewReady === 'true') return;
    const links = Array.from(menu.querySelectorAll('.mega-menu__list a[href*="/collections/"]'));
    if (!links.length || !previewPanel(menu)) return;
    menu.dataset.ninjaPreviewReady = 'true';

    links.forEach((link) => {
      link.addEventListener('pointerenter', () => activate(link, menu));
      link.addEventListener('focus', () => activate(link, menu));
    });
  }

  function initialize(root = document) {
    root.querySelectorAll('.mega-menu').forEach(bind);
  }

  initialize();
  new MutationObserver(() => initialize()).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();